import React, { useEffect } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId, selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { useSaveScorecardResultMutation } from '../../store/ai/scorecard'
import { FormProvider, useForm } from 'react-hook-form'
import { isArray, removeEmptyItems } from '../../common/util'
import { Col, Row } from 'react-bootstrap'
import { Scorecard as ScorecardModel, ScorecardResult } from '../../models/Scorecard'
import { ClientProfileFormBody } from './ClientProfileFormBody'

interface ClientProfileFormProps {
  scorecard: ScorecardModel
  contactId: string
  scorecardResult: ScorecardResult | null
}

export const ClientProfileForm: React.FC<ClientProfileFormProps> = ({ scorecard, contactId, scorecardResult }) => {
  const accountId = useAppSelector(selectAccountId)
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const [saveScorecardResult] = useSaveScorecardResultMutation()

  const form = useForm()

  useEffect(() => {
    if (!scorecardResult) {
      return
    }
    Object.entries(removeEmptyItems({ ...scorecardResult.result })).forEach(([k, v]) => {
      if (isArray(v)) {
        if ((v as Array<any>).length !== 0) {
          form.setValue(k, v)
        }
      } else {
        form.setValue(k, v)
      }
    })
  }, [scorecardResult, form])

  const onSubmit = async (data: { [key: string]: any }) => {
    await saveScorecardResult({
      accountId,
      userId: contactId,
      result: removeEmptyItems(data),
      source: { type: 'user', userId: currentUserId },
      previousRevision: scorecardResult!.revision,
      scorecardId: scorecardResult!.scorecardId,
    })
  }

  const onReset = () => {
    if (scorecardResult) {
      form.clearErrors()
      form.reset(scorecardResult.result)
    }
  }

  if (!scorecardResult) {
    return (
      <Row>
        <Col>
          <div className='paragraph-medium-extended zocks-text-gray-500 py-1 pe-4 ps-4'>No result available.</div>
        </Col>
      </Row>
    )
  }

  return (
    <FormProvider {...form}>
      <ClientProfileFormBody scorecard={scorecard} scorecardResult={scorecardResult} onSubmit={onSubmit} onReset={onReset} />
    </FormProvider>
  )
}
